import { EventDialog } from "./EventDialog";
import { MissionEventRecord } from "../types";
import { useRecordContext, useRefresh } from "react-admin";
import { useUpdateSubmit } from "../../../forms";

type UpdateEventDialogProps = {
	closeDialog: () => void;
};

export const UpdateEventDialog = (props: UpdateEventDialogProps) => {
	const event = useRecordContext<MissionEventRecord>();

	const refresh = useRefresh();

	const saveUpdate = useUpdateSubmit(
		"mission-events",
		"Mission event updated",
		{
			resource: "missions",
			idColumn: "mission_id",
			view: "show",
		},
		() => {
			refresh();
			props.closeDialog();
		}
	);
	return <EventDialog {...props} title={event.name} onSubmit={saveUpdate} />;
};
